import { useTranslation } from "react-i18next"
import { peopleURL } from "@/utils"
import { TagsFilter } from "../../controls"
import { TagBox } from "./TagBox"

export function Tag({ id }: { id: string }) {
  const { t } = useTranslation("tags")
  return <TagBox href={`${peopleURL}?${TagsFilter.filterName}=${id}`}>{t(id).replace(/\s/g, "\u00A0")}</TagBox>
}
